import React, { useContext, useEffect, useState } from "react";
import BloqueadoReservaList from "../../components/BloqueadoReservaList/BloqueadoReservaList";
import bloqueadosReservaContext from "../../context/bloqueadosReserva/bloqueadosReservaContext";
import AbmBloqueadoReserva from "../../components/abmBloqueadoReserva/AbmBloqueadoReserva";
import Swal from 'sweetalert2';
import '../product/Product.css';
import './BloqueadoReserva.css';

function BloqueadoReserva() {

    const bContext = useContext(bloqueadosReservaContext);
    const { bloqueados, actualizarBloqueados, eliminarTodos } = bContext;
    const [showAbm, setShowAbm] = useState(false);

    useEffect(() => {
        actualizarBloqueados();
    }, []);

    const handleEliminarTodos = async () => {
        if (bloqueados.length === 0) {
            Swal.fire({ title: 'Sin registros', text: 'No hay registros para eliminar', icon: 'info' });
            return;
        }
        const result = await Swal.fire({
            title: 'Eliminar todos los registros',
            text: `Se eliminarán ${bloqueados.length} registro(s). ¿Está seguro?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff0000',
            confirmButtonText: 'Sí, eliminar todos',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
            const res = await eliminarTodos();
            if (res) {
                Swal.fire({ title: 'Eliminados', text: 'Todos los registros fueron eliminados', icon: 'success' });
            }
        }
    }

    return (
        <div className="productView">
            <button className="agregar-productos-btn" onClick={() => setShowAbm(true)}>
                +
            </button>
            <button className="eliminar-todos-btn" onClick={handleEliminarTodos}>
                Eliminar Todos
            </button>
            <BloqueadoReservaList bloqueados={bloqueados} />
            {showAbm && <AbmBloqueadoReserva setShowAbm={setShowAbm} />}
        </div>
    );
}

export default BloqueadoReserva;
